"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  surchargeAndMiscellaneous: {
    title: '附加费及杂费',
    exportExcel: '导出',
    result: '查询结果',
    supplement: '(附加费公布付费方式为默认方式，可以根据客户要求选择付费方式。)',
    defaultPaidType: '只显示默认付费方式',
    por: '接货地',
    destination: '目的地',
    del: '目的地',
    costType: '费用类型',
    surcharge: '附加费',
    miscellaneous: '杂费',
    boxPile: '箱型',
    containerType: '箱型',
    cargoType: '货类',
    paidType: '付费方式',
    pp: 'PP',
    cc: 'CC',
    chargeCode: '费用代码',
    rate: '费率',
    currency: '币种',
    transitClause: '运输条款'
  }
};